import React from 'react';
import { Bell, BellRing, TriangleAlert } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';

export default function NotificationStats({ stats }) {
    if (!stats) return null;

    const unreadPercentage = stats.total > 0 ? Math.round((stats.unread / stats.total) * 100) : 0;

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-3">
            <StatCard label="Total Notificaciones" value={formatNumber(stats.total || 0)} icon={<Bell />} tone="brand" hint="Notificaciones registradas" />
            <StatCard label="Sin Leer" value={formatNumber(stats.unread || 0)} icon={<BellRing />} tone="warning" hint={`${unreadPercentage}% del total`} />
            <StatCard
                label="Críticas"
                value={formatNumber(stats.critical || 0)}
                valueTone={stats.critical > 0 ? 'danger' : undefined}
                icon={<TriangleAlert />}
                tone="danger"
                hint="Requieren atención inmediata"
            />
        </div>
    );
}
